const orderStatusMixin = {
  methods: {
    determineOrderStatusDot(o) {
      let count = 0;
      let cancelledCount = 0;
      let holdCount = 0;
      let error = false;
      let totalCount = 0;
      if (o.orderLine) {
        o.orderLine.forEach((oL) => {
          if (oL.status !== 'Ignore' && !oL.sku?.includes('SHIPPING') && !oL.sku?.includes('SMAC10PM')) {
            totalCount += 1;
          }
          if (oL.status === 'Error') {
            error = true;
          } else if (oL.status === 'Shipped' || oL.status === 'Delivered' || oL.status === 'Returned') {
            count += 1;
          } else if (oL.status === 'Do not ship' || oL.status === 'Cancelled') {
            cancelledCount += 1;
          } else if (oL.status === 'Waiting for review' && (!oL.width || !oL.height || !oL.thickness || !oL.merv)) {
            holdCount += 1;
          }
        });
        if (error) {
          return 'error';
        }
        if (cancelledCount === totalCount) {
          return 'cancelled';
        }
        if (holdCount === totalCount) {
          return 'waiting';
        }
        if (count === 0) {
          return 'red-dot';
        }
        if (count < totalCount) {
          return 'yellow-dot';
        }
        if (count === totalCount) {
          return 'green-dot';
        }
      } else if (o.orderLines) {
        o.orderLines.forEach((oL) => {
          if (oL.status !== 'Ignore' && !oL.sku?.includes('SHIPPING') && !oL.sku?.includes('SMAC10PM')) {
            totalCount += 1;
          }
          if (oL.status === 'Error') {
            error = true;
          } else if (oL.status === 'Shipped' || oL.status === 'Delivered' || oL.status === 'Returned') {
            count += 1;
          } else if (oL.status === 'Do not ship' || oL.status === 'Cancelled') {
            cancelledCount += 1;
          } else if (oL.status === 'Waiting for review') {
            holdCount += 1;
          }
        });
        if (error) {
          return 'error';
        }
        if (cancelledCount === totalCount) {
          return 'cancelled';
        }
        if (holdCount === totalCount) {
          return 'waiting';
        }
        if (count === 0) {
          return 'red-dot';
        }
        if (count < totalCount) {
          return 'yellow-dot';
        }
        if (count === totalCount) {
          return 'green-dot';
        }
      }
      if (o.status) {
        if (o.status === 'Shipped' || o.status === 'Delivered' || o.status === 'Returned') {
          return 'green-dot';
        }
        if (o.status === 'Do not ship'
          || o.status === 'Waiting for review'
          || o.status === 'Ignore') {
          return 'cancelled';
        }
        return 'red-dot';
      }
      return '';
    },
    determineOrderStatus(status) {
      if (status === 'All items shipped'
        || status === 'Shipped'
        || status === 'Delivered') {
        return 'green-text no-wrap';
      }
      if (status === 'Partially shipped') {
        return 'yellow-text no-wrap';
      }
      if (status === 'Cancelled'
        || status === 'Do not ship'
        || status === 'Waiting for review'
        || status === 'Waiting for review'
        || status === 'Ignore') {
        return 'black-text';
      }
      return 'red-text no-wrap';
    },
    createTrackingLink(o) {
      const {
        shippingOption,
        trackingNumber,
      } = o;
      if (shippingOption?.toLowerCase() === 'fedex') {
        return `https://www.fedex.com/fedextrack/?trknbr=${trackingNumber}`;
      }

      if (shippingOption?.toLowerCase() === 'usps') {
        return `https://tools.usps.com/go/TrackConfirmAction?qtc_tLabels1=${trackingNumber}`;
      }

      if (shippingOption?.toLowerCase() === 'ups' || shippingOption === 'up3') {
        return `https://wwwapps.ups.com/WebTracking/processInputRequest?TypeOfInquiryNumber=T&InquiryNumber1=${trackingNumber}`;
      }

      if (shippingOption?.toLowerCase() === 'omni') {
        return `https://webapps.omnilogistics.com/tracking/viewShipment?id=${trackingNumber}`;
      }

      return null;
    },
  },
};

export default orderStatusMixin;
